<template>
  <div>
    <ejs-dialog
      ref="createPriceUnitCopyPopup"
      :header="`골프요금 단가복사`"
      :allowDragging="true"
      :showCloseIcon="true"
      width="310"
      :isModal="true"
      :close="onPriceUnitCopyPopupClosed"
    >
      <div class="window golfPriceUnitCopy">
        <div class="windowContent">
          <div class="content-wrapper">
            <div class="content-body">
              <article class="body-article">
                <!-- 아코디언 : accordion / 닫힘 : close -->
                <section class="article-section section-01">
                  <div class="section-header">
                    <div class="header-left">
                      <div class="header-title">단가 복사</div>
                    </div>
                  </div>
                  <div class="section-body">
                    <div class="body-data">
                      <div class="data-outer">
                        <div class="data-inner">
                          <ul class="data-content">
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title">복사대상</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group date">
                                    <div class="form">
                                      <input-date
                                        ref="priceUnitCopyDatePicker"
                                        format="YYYY-MM-DD"
                                        v-model="originDate"
                                        disabled="true"
                                      />
                                    </div>
                                    <div class="validation">
                                      <div class="e-tip-content"></div>
                                      <div class="e-tip-top"></div>
                                    </div>
                                  </li>
                                  <li class="item form-group text">
                                    (<span
                                      :style="{
                                        color: getDayOfWeekCaptionColor(
                                          originDateObj
                                        ),
                                      }"
                                      >{{
                                        getDayOfWeekCaption(originDateObj)
                                      }}</span
                                    >)
                                    <div class="validation">
                                      <div class="e-tip-content"></div>
                                      <div class="e-tip-top"></div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </li>
                            <li class="field">
                              <!-- 필수 : required -->
                              <div class="title required">적용일자</div>
                              <div class="content">
                                <ul class="row">
                                  <li class="item form-group date">
                                    <div class="form">
                                      <input-date
                                        ref="priceUnitCopyDatePicker"
                                        format="YYYY-MM-DD"
                                        v-model="copyDate"
                                        :notClear="true"
                                      />
                                    </div>
                                    <div class="validation">
                                      <div class="e-tip-content"></div>
                                      <div class="e-tip-top"></div>
                                    </div>
                                  </li>
                                  <li class="item form-group text">
                                    (<span
                                      :style="{
                                        color: getDayOfWeekCaptionColor(
                                          copyDateObj
                                        ),
                                      }"
                                      >{{
                                        getDayOfWeekCaption(copyDateObj)
                                      }}</span
                                    >)
                                    <div class="validation">
                                      <div class="e-tip-content"></div>
                                      <div class="e-tip-top"></div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                          <div class="border-left"></div>
                          <div class="border-right"></div>
                          <div class="border-top"></div>
                          <div class="border-bottom"></div>
                        </div>
                      </div>
                      <div class="border-left"></div>
                      <div class="border-right"></div>
                      <div class="border-top"></div>
                      <div class="border-bottom"></div>
                    </div>
                  </div>
                </section>
              </article>
            </div>
          </div>
        </div>
        <div class="windowFooter">
          <ul class="button">
            <li class="save keyColor">
              <erp-button
                  button-div="SAVE"
                  :is-key-color="true"
                  :is-shortcut-button="true"
                  @click.native="onCopyPriceUnit"
              >
                저장
              </erp-button>
            </li>
            <li class="close">
              <erp-button
                  button-div="CLOSE"
                  @click.native="onPriceUnitCopyPopupClosed"
              >
                닫기
              </erp-button>
            </li>
          </ul>
        </div>
      </div>
    </ejs-dialog>
  </div>
</template>

<script>
import commonMixin from "@/views/layout/mixin/commonMixin";
import confirmDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";
import {
  getDayOfWeekCaptionColor,
  getDayOfWeekCaption,
  getFormattedDate,
} from "@/utils/date";
import InputDate from "@/components/common/datetime/InputDate";
import ErpButton from "@/components/button/ErpButton";

export default {
  name: "priceUnitCopyPopup",
  mixins: [commonMixin, confirmDialogMixin],
  components: {
    InputDate,
    ErpButton,
  },

  mounted() {
    this.copyDate = getFormattedDate(new Date());
  },
  data() {
    return {
      originDate: null,
      copyDate: null,
    };
  },
  computed: {
    originDateObj() {
      return new Date(this.originDate);
    },
    copyDateObj() {
      return new Date(this.copyDate);
    },
  },
  methods: {
    getDayOfWeekCaptionColor,
    getDayOfWeekCaption,
    preventEnterEvent(event) {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    },
    onShowPriceUnitCopy(originDate) {
      this.originDate = originDate;
      this.$refs.createPriceUnitCopyPopup.show();
    },
    onCopyPriceUnit() {
      if (!this.copyDate) {
        return this.errorToast(
          this.$t("main.validationMessage.requiredMessage", ["적용일자"])
        );
      }

      this.$emit("copy", this.copyDate, this.originDate);
    },
    onPriceUnitCopyPopupClosed() {
      this.$refs.createPriceUnitCopyPopup.hide();
      this.$emit("popupClosed");
    },
  },
};
</script>
